import { FC, ReactNode, createContext, useContext, useState } from 'react';
import { useGetCourseQuery, type CourseWithProgress } from '@teachur/http-client';
import { Loader } from '@new/common/ui/Loader/Loader';
import { EmptyState } from '@new/common/ui/EmptyState/EmptyState';

export type CourseStep = 'self' | 'exam' | 'project' | 'hearing';

interface SingleCourseContextValue {
  course: CourseWithProgress | null;
  activeStep: CourseStep | null;
  setActiveStep: (step: CourseStep | null) => void;
}

const SingleCourseContext = createContext<SingleCourseContextValue | undefined>(undefined);

interface SingleCourseProviderProps {
  courseId: number;
  children: ReactNode;
}

export const SingleCourseProvider: FC<SingleCourseProviderProps> = ({ courseId, children }) => {
  const [activeStep, setActiveStep] = useState<CourseStep | null>('self');

  const { data: course, isLoading } = useGetCourseQuery(courseId);

  // useEffect(() => {
  //   if (!course) return;

  //   setActiveStep(getCurrentCourseStep(course));
  // }, [course]);

  if (isLoading) return <Loader />;

  if (!course) {
    return (
      <EmptyState
        message="Course not found"
        description="The course you are looking for does not exist."
      />
    );
  }

  return (
    <SingleCourseContext.Provider value={{ course, activeStep, setActiveStep }}>
      {children}
    </SingleCourseContext.Provider>
  );
};

export const useSingleCourse = (): SingleCourseContextValue => {
  const context = useContext(SingleCourseContext);

  if (context === undefined) {
    throw new Error('useSingleCourse must be used within a SingleCourseProvider');
  }

  return context;
};
